export enum RefundStrategy {
  PIX,
  BANK_ACCOUNT,
}
